<ng-container *transloco="let t">
  <h1 mat-dialog-title>{{ t('support.changelog_title') }}</h1>
  <div mat-dialog-content>
    @if (loading) {
      <mat-progress-bar mode="indeterminate" />
    } @else if (loadError) {
      <p class="text-muted">{{ t('support.changelog_error') }}</p>
    } @else if (data && data.result.length === 0) {
      <p class="text-muted">{{ t('support.changelog_empty') }}</p>
    } @else if (data) {
      <p class="text-muted margin-sm-bottom">{{ t('support.changelog_total', { count: data.total }) }}</p>
      <mat-accordion>
        @for (snap of data.result; track trackSnapshot($index, snap)) {
          <mat-expansion-panel [expanded]="$first">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ t('support.changelog_release', { version: snap.appVersion }) }}</mat-panel-title>
              <mat-panel-description> {{ snap.periodStartAt | date: 'medium' }} – {{ snap.periodEndAt | date: 'medium' }} </mat-panel-description>
            </mat-expansion-panel-header>
            @for (it of snap.items; track trackItem($index, it)) {
              <div class="changelog-ticket">
                <mat-list>
                  <mat-list-item>
                    <span matListItemTitle>{{ it.summary }}</span>
                    <span matListItemLine>
                      {{ it.jiraKey }}
                      @if (it.resolvedAt) {
                        — {{ it.resolvedAt | date: 'short' }}
                      }
                    </span>
                  </mat-list-item>
                </mat-list>
                @if (it.description) {
                  <mat-accordion class="changelog-ticket-desc-accordion">
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>{{ t('support.changelog_item_description') }}</mat-panel-title>
                      </mat-expansion-panel-header>
                      <p class="mat-body-small changelog-ticket-desc-body">{{ it.description }}</p>
                    </mat-expansion-panel>
                  </mat-accordion>
                }
              </div>
            } @empty {
              <p class="text-muted">{{ t('support.changelog_no_items') }}</p>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </div>
  <div mat-dialog-actions>
    <span class="flex-grow-1"></span>
    <button mat-button mat-dialog-close type="button">{{ t('general.close') }}</button>
  </div>
</ng-container>
